import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  NbButtonModule,
  NbCardModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbSelectModule,
  NbSidebarModule,
  NbThemeModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { LogoWithSubtitleComponent } from './components/logo-with-subtitle/logo-with-subtitle.component';
import { PublicationsComponent } from './pages/publications/publications.component';
import { SponsorsComponent } from './pages/sponsors/sponsors.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { DisplayGeneComponent } from './pages/display-gene/display-gene.component';
import { UserAuthService } from './services/user-auth.service';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { AboutComponent } from './pages/about/about.component';
import { DownloadsComponent } from './pages/downloads/downloads.component';
import { ContactComponent } from './pages/contact/contact.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { DatasetSelectionComponent } from './pages/dataset-selection/dataset-selection.component';
import { Gwas15Component } from './pages/gwas15/gwas15.component';
import { ToolSelectionComponent } from './pages/tool-selection/tool-selection.component';
import { GeneLevelMultiComponent } from './pages/gene-level-multi/gene-level-multi.component';
import { SnpLevelMultiComponent } from './pages/snp-level-multi/snp-level-multi.component';
import { GseaAnalysisComponent } from './pages/gsea-analysis/gsea-analysis.component';

export function authFactory(auth: UserAuthService) {
  return () => auth.init();
}
@NgModule({
  declarations: [
    AppComponent,
    LogoWithSubtitleComponent,
    PublicationsComponent,
    SponsorsComponent,
    DisplayGeneComponent,
    ComingSoonComponent,
    AboutComponent,
    DownloadsComponent,
    ContactComponent,
    HomepageComponent,
    DatasetSelectionComponent,
    Gwas15Component,
    ToolSelectionComponent,
    GeneLevelMultiComponent,
    SnpLevelMultiComponent,
    GseaAnalysisComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NbThemeModule.forRoot({ name: 'rancho-gem-theme' }),
    NbLayoutModule,
    NbButtonModule,
    NbSidebarModule.forRoot(),
    NbCardModule,
    NbInputModule,
    NbFormFieldModule,
    NbIconModule,
    NbEvaIconsModule,
    NbSelectModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [
          environment.baseUrl,
          environment.oauthConfig.userinfoEndpoint!,
        ],
        sendAccessToken: true,
      },
    }),
    HttpClientModule,
    NgxSpinnerModule.forRoot({ type: 'cog' }),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: authFactory,
      deps: [UserAuthService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
